import { defineNuxtPlugin } from 'nuxt/app'
import PortalVue from 'portal-vue'
import { logger } from '../utility/logger'

export default defineNuxtPlugin(({ vueApp }) => {
  logger('portal-vue plugin loaded')
  vueApp.use(PortalVue)
})
